<template>

	<!--Basic Box-->
	<div class="basic-box__row-wrap">

		<!--Row Item-->
		<div class="basic-box__row hr">
			<div class="basic-box__row-inner">

				<!--Time-->
				<div class="basic-box__row-item basic-box__row-item_time">
					{{event.time.$date.$numberLong | time('x')}}
				</div>

				<!--Avatar-->
				<div class="basic-box__row-item basic-box__row-item_avatar-wrap">
					<!--<img class="basic-box__avatar" src="../../assets/img/doctor-1.jpg" alt="avatar">-->
				</div>

				<!--Name-->
				<div class="basic-box__row-item basic-box__row-item_name">
					{{event | eventMessage}}
				</div>

				<!--Buttons-->
				<div class="basic-box__row-item basic-box__btns">
					<button class="basic-box__btn basic-box__btn_confirm" @click="sendAnswer(event, 'approve')">
						Подтвердить
					</button>

					<button class="basic-box__btn basic-box__btn" @click="sendAnswer(event, 'reject')">
						Отменить
					</button>
				</div>

			</div>
		</div>
		<!--Row Item End-->

	</div>
	<!--Basic Box-->

</template>
<script>
	import messageGenerator from '@/common/messageGenerator'

	export default {
		name: "NotificationItem",
		props: ['event'],
		filters: {
			eventMessage(event) {
				return messageGenerator.get(event)
			}
		},
		methods: {
			sendAnswer(notification, responseType) {
				let type = notification.type.match(/^[a-z_]+/)

				this.$store.dispatch(type + '/sendAnswer', {model: notification, responseType: responseType})
					.then(() => this.$store.dispatch('notification/read', notification._id))
					.then(() => this.$event.send('updateNotifications', {}))
			}
		}
	}
</script>



// WEBPACK FOOTER //
// NotificationItem.vue?69109ca8